//values
let html_error_messages_prefix = '<div class="form-status__message form-status__message--error fs-body-75"><ul tabindex="0" data-form-status="">';
let html_error_messages_suffix = '</ul></div>';

//ready
jQuery(document).ready(function () {

  //values
  const element_register_form = document.querySelectorAll('#customer_login');
  const element_login_fp_form = document.querySelectorAll('#login_fp__form');

  //each
  element_register_form.forEach((form) => {

    //values
    const element_submit_button_2 = form.querySelector('#registerFormButton');

    //if
    if(form && element_submit_button_2) {

      //on
      element_submit_button_2.onclick = function(e) {

        //prevent
        e.preventDefault();

        //clear
        let error_messages_elements_1 = form.querySelector('.form-status');
        let error_messages_elements_2 = document.getElementsByClassName('form-status');
        let error_messages_elements_3 = document.getElementsByClassName('form-status__message');

        //if
        if(error_messages_elements_1) {

          //values
          let error_messages_children = Array.prototype.slice.call(error_messages_elements_1.childNodes);

          //each
          error_messages_children.forEach(function(child) {

            //remove
            error_messages_elements_1.removeChild(child);

          });
          
        }

        //if
        if(error_messages_elements_2) {

          //while
          while(error_messages_elements_2.length > 0) {

            //remove
            error_messages_elements_2[0].parentNode.removeChild(error_messages_elements_2[0]);
    
          }

        }

        //if
        if(error_messages_elements_3) {

          //while
          while(error_messages_elements_3.length > 0) {
    
            //remove
            error_messages_elements_3[0].parentNode.removeChild(error_messages_elements_3[0]);
            
          }

        }

        //run
        custom_login(form);

      }
      
    }
  
  });

  //each
  /*element_login_fp_form.forEach((form) => {

    //values
    const element_submit_button = form.querySelector('#registerFormFpButton');

    //if
    if(form && element_submit_button) {

      //on
      element_submit_button.onclick = function(e) {

        //prevent
        e.preventDefault();

        //clear
        let error_messages_elements_1 = form.querySelector('.form-status');
        let error_messages_elements_2 = document.getElementsByClassName('form-status');
        let error_messages_elements_3 = document.getElementsByClassName('form-status__message');

        //if
        if(error_messages_elements_1) {

          //values
          let error_messages_children = Array.prototype.slice.call(error_messages_elements_1.childNodes);

          //each
          error_messages_children.forEach(function(child) {

            //remove
            error_messages_elements_1.removeChild(child);

          });
          
        }

        //if
        if(error_messages_elements_2) {

          //while
          while(error_messages_elements_2.length > 0) {

            //remove
            error_messages_elements_2[0].parentNode.removeChild(error_messages_elements_2[0]);

          }

        }

        //if
        if(error_messages_elements_3) {

          //while
          while(error_messages_elements_3.length > 0) {

            //remove
            error_messages_elements_3[0].parentNode.removeChild(error_messages_elements_3[0]);
            
          }

        }

        //run
        custom_fp(form);

      }

    }

  });*/

});

//functions
function custom_login(form) {

  //values
  let data_email = form.getElementsByClassName('data_input_email')[0].value;
  let data_password = form.getElementsByClassName('data_input_password')[0].value;
  
  //if
  if(!data_email || !data_password) {

      //error
      form.insertAdjacentHTML('beforebegin', html_error_messages_prefix + '<li>Please fill out the email and password fields.</li>' + html_error_messages_suffix);

      //return
      return;

  }

  //values        
  let account_login = $.ajax({
    url: '/account/login',
    method: 'post',
    data: serialize_form(form),
    dataType: 'html',
    async: true
  }).done(function(html) {
    
    //if
    if(html.indexOf('form-status__message--error') !== -1) {
      
      //values
      let temp_element = document.createElement('body');

      //set
      temp_element.innerHTML = html;

      //values
      let html_element_1 = temp_element.querySelector('.form-status');

      //prepend
      form.insertBefore(html_element_1, form.firstChild);

    } else {

      //submit
      form.submit();

    }

  });
  
  //return
  return account_login;
  
}

function custom_fp(form) {

  //values
  let data_email = form.getElementsByClassName('data_input_email')[0].value;
  
  //if
  if(!data_email) {

      //error
      form.insertAdjacentHTML('beforebegin', html_error_messages_prefix + '<li>Please fill out the email field.</li>' + html_error_messages_suffix);

      //return
      return;

  }

  //values        
  let account_fp = $.ajax({
    url: '/account/recover',
    method: 'post',
    data: serialize_form(form),
    dataType: 'html',
    async: true
  }).done(function(html) {
    
    //if
    if(html.indexOf('form-status__message--error') !== -1) {
      
      //values
      let temp_element = document.createElement('body');

      //set
      temp_element.innerHTML = html;

      //values
      let html_element_1 = temp_element.querySelector('.form-status');

      //prepend
      form.insertBefore(html_element_1, form.firstChild);

    } else {

      //submit
      form.submit();

    }

  });
  
  //return
  return account_fp;

}